import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../components/router/router-tabbed-navigation';
import { PortfolioTransactionsTable } from '../../../../../../../../features/portfolio/transaction/portfolio-transactions-table';
import { getPageHead } from '../../../../../../../../util/routing/meta';
import type { ViewContext } from '../../../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/transaction')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RegistrationAccountSummaryList,
      label: 'Transactions',
      order: 4,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RegistrationAccountSummaryList>,
  head: () => getPageHead('Account Transactions'),
  component: AccountPortfolioTransactionList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.RegistrationAccountSummaryList}
    />
  );
}

function AccountPortfolioTransactionList() {
  const { accountId } = Route.useParams();
  const viewContext: ViewContext = useMemo(
    () => ({
      kind: 'account',
      accountId,
    }),
    [accountId],
  );

  return (
    <PageLayout.Section noBorder>
      <PortfolioTransactionsTable HeaderActions={TableHeader} view={viewContext} />
    </PageLayout.Section>
  );
}
